import domReady from '@wordpress/dom-ready';

domReady(() => {
    const productCollectionCarouselsNodes = Array.from(document.querySelectorAll('.wp-block-woocommerce-product-collection.uses-carousel.embla'));

    if(productCollectionCarouselsNodes .length) {
        productCollectionCarouselsNodes .forEach((productCollectionCarouselNode) => {
            
            const emblaContainerNode = productCollectionCarouselNode.querySelector('.wp-block-woocommerce-product-template');
            
            if(emblaContainerNode) {
                emblaContainerNode.classList.add('embla__container');
                
                const emblaViewportNode = document.createElement('div');
                emblaViewportNode.classList.add('embla__viewport');
                // insert wrapper before el in the DOM tree
                emblaContainerNode.parentNode.insertBefore(emblaViewportNode, emblaContainerNode);
                // move el into wrapper
                emblaViewportNode.appendChild(emblaContainerNode);

                const html = `
                    <div class="embla__navigation">
                        <button class="embla__button embla__button--prev" aria-label="previous slide">
                            <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="26.6637" y="41.6637" width="30" height="30" rx="15" transform="rotate(-150 26.6637 41.6637)" stroke="#2D2D2D"/>
                                <path d="M26.7246 21.3242L15.6218 21.3242M15.6218 21.3242L21.2246 15.6733M15.6218 21.3242L20.9254 26.6733" stroke="#474747" stroke-linecap="round"/>
                            </svg>
                        </button>
                        <button class="embla__button embla__button--next" aria-label="next slide">
                            <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="15.683" y="0.683013" width="30" height="30" rx="15" transform="rotate(30 15.683 0.683013)" stroke="#2D2D2D"/>
                                <path d="M15.6221 21.0224H26.7249M26.7249 21.0224L21.1221 26.6733M26.7249 21.0224L21.4213 15.6733" stroke="#474747" stroke-linecap="round"/>
                            </svg>
                        </button>

                        <div class="embla__dots" style="--dot-color: #D9D9D9;--dot-color-highlight: #426624;"></div>
                    </div>
                `;
                emblaViewportNode.insertAdjacentHTML('beforeend', html);
                // .embla__navigation
                // ('.embla__navigation > .embla__button--prev');
            // const nextBtn = emblaViewportNode.querySelector('.embla__navigation > .embla__button--next');

                // const prevBtn = thumbsViewportNode.querySelector(':scope > .embla__button--prev');
                // const nextBtn = thumbsViewportNode.querySelector(':scope > .embla__button--next');
                const emblaSlidesNodes = [...productCollectionCarouselNode.querySelectorAll('.wc-block-product')];

                if(emblaSlidesNodes) {
                    emblaSlidesNodes.forEach(slide => {
                        slide.classList.add('embla__slide');

                        const emblaSlideContentNode = document.createElement('div');
                        emblaSlideContentNode.classList.add('embla__slide-content');
                        
                        while (slide.childNodes.length > 0) {
                            emblaSlideContentNode.appendChild(slide.childNodes[0]);
                        }

                        slide.appendChild(emblaSlideContentNode);
                    });
                }
            }
        });
    }
});